<template>
  <v-snackbar
    :absolute="true"
    :app="true"
    :vertical="true"
    :multi-line="true"
    top="top"
    :color="message.color"
    v-model="display"
    :timeout="message.timeout"
  >
    {{ message.text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="clearMessage">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({}),
  methods: {
    ...mapActions(["clearMessage"])
  },
  computed: {
    ...mapState({ message: state => state.Message.message }),
    display: {
      get() {
        return this.message.display;
      },
      set(v) {
        if (v) return;
        this.clearMessage();
      }
    }
  }
};
</script>

<style>
</style>